import React, { useState, useEffect } from 'react';
import Table from '../../../../component/Table';
import Card from '../../../../component/Card';
import DatePicker from 'react-datepicker';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { toast } from 'view/component/Alert';
import CustomDatePicker from 'view/component/CustomDatePicker';
import FormTanggalKunjungan from './FormTanggalKunjungan';
import HistoryTanggalKunjungan from './HistoryTanggalKunjungan';

const View = ({
  data,
  handleSubmit,
  setTanggalKunjungan,
  visitDateHistory,
}) => {
  const [ isFormDisabled, setIsFormDisabled ] = useState([]);
  const [ verifiedStatus, setVerifiedStatus ] = useState({});
  const [ keterangan, setKeterangan ] = useState({});
  const [ verifiedComplete, setVerifiedComplete ] = useState('');
  const [ isModalShow, setIsModalShow ] = useState(false);
  const [ isModal2Show, setIsModal2Show ] = useState(false);

  useEffect(() => {
    data.forEach((d, i) => {
      if (d.verified === 'yes') {
        setVerifiedComplete((prevState) => ({ ...prevState, [ d.id ]: 1 }));
        setIsFormDisabled((prevState) => ({ ...prevState, [ i ]: true }));
      }
      if (!d.verified) {
        setIsFormDisabled((prevState) => ({ ...prevState, [ i ]: true }));
      }
      setKeterangan((prevState) => ({ ...prevState, [ i ]: d.keterangan }));
    });
  }, [ data ]);

  const openFile = (url) => {
    const win = window.open(url, '_blank');
    if (!win) {
      win.focus();
    }
  };

  const handleSelectChange = (e, i) => {
    e.persist();
    setVerifiedStatus((state) => ({ ...state, [ i ]: e.target.value }));
    setIsFormDisabled((prevState) =>
      e.target.value === 'no'
        ? { ...prevState, [ i ]: false }
        : { ...prevState, [ i ]: true }
    );
    setKeterangan((prevState) => ({ ...prevState, [ i ]: '' }));
  };

  const handleChange = (e, i) => {
    e.persist();
    setKeterangan((prevState) => ({ ...prevState, [ i ]: e.target.value }));
  };

  return (
    <div className='container-fluid '>
      <div className='row justify-content-center'>
        <div className='col-lg-12'>
          <Card marginTop={ 2 }>
            <Card.Body>
              <div className='mb-3'>
                <h2 className='d-inline'>Verifikasi Persyaratan</h2>
                <span
                  className='text-primary ml-3'
                  style={ { cursor: 'pointer' } }
                  onClick={ () => setIsModalShow(true) }>
                  <span className='d-inline'>Rencana kunjungan</span>
                </span>
              </div>
              <FormTanggalKunjungan
                isModalShow={ isModalShow }
                setIsModalShow={ setIsModalShow }
                data={ data }
                verifiedComplete={ verifiedComplete }
                setTanggalKunjungan={ setTanggalKunjungan }
                visitDateHistory={ visitDateHistory || [] }
              />
              {/* <Modal
                show={ isModalShow }
                onHide={ () => setIsModalShow(false) }
                size='sm'
                centered>
                <Modal.Body>
                  {Object.values(data).length !== 0 &&
                  Object.values(data).length ===
                    Object.values(verifiedComplete).length ? (
                      <div className='d-flex flex-column justify-content-center'>
                        <h2 className='align-self-center'>
                          Tanggal : {moment(tanggal).format('DD-MM-YYYY')}
                        </h2>
                        <div className='form-group'>
                          <label className='form-control-label'>Pengubah</label>
                          <input
                            value={ name }
                            className='form-control'
                            placeholder='Pengubah'
                            onChange={ (e) => setName(e.target.value) }
                          />
                        </div>
                        <div className='form-group'>
                          <label className='form-control-label'>Alasan</label>
                          <input
                            value={ reason }
                            className='form-control'
                            placeholder='Alasan'
                            onChange={ (e) => setReason(e.target.value) }
                          />
                        </div>
                        <div className='form-group'>
                          <label className='form-control-label'>
                          Tanggal kunjungan
                          </label>
                          <CustomDatePicker
                            value={ tanggal }
                            onChange={ (date) => setTanggal(date) }
                          />
                        </div>
                        <div className='d-inline align-self-center mt-2'>
                          <DatePicker
                            selected={ tanggal }
                            onChange={ (date) => setTanggal(date) }
                          />
                        </div>
                        <div className='d-flex justify-content-center mt-2'>
                          <button
                          onClick={ () => setIsModalShow(false) }
                          className='mr-3'>
                          Cancel
                        </button>
                          <button
                            className='btn btn-success'
                            onClick={ () =>
                              setTanggalKunjungan(
                                {
                                  date: moment(tanggal).format('YYYY-MM-DD'),
                                  name,
                                  reason,
                                },
                                () => setIsModalShow(false)
                              )
                            }>
                          Confirm
                          </button>
                        </div>
                      </div>
                    ) : (
                      <h2 className='text-center'>
                      Pastikan semua persyaratan terverifikasi
                      </h2>
                    )}
                </Modal.Body>
              </Modal> */}
              <Table
                pagination={ false }
                headers={ [ 'No', 'Nama', 'File', 'Verifikasi', 'Keterangan', '' ] }
                data={ data }
                columnMapper={ (value, i) => {
                  return [
                    <span
                      style={ {
                        whiteSpace: 'initial',
                        overflow: 'hidden',
                      } }>
                      {value.name || value.detail.name}
                    </span>,
                    value.upload ? (
                      <>
                        <span
                          onClick={ () => openFile(value.upload) }
                          className='text-primary mr-2'
                          style={ { cursor: 'pointer' } }>
                          Lihat file persyaratan
                        </span>
                        {value.update === 1 ||
                        value.update_after_reject === 1 ? (
                            <span className='text-warning'>
                            <i className='fas fa-exclamation-circle' />
                          </span>
                          ) : (
                            ''
                          )}
                      </>
                    ) : (
                      'Tidak ada file'
                    ),
                    value.verified === 'yes' || verifiedComplete[ value.id ] ? (
                      'Terverifikasi'
                    ) : (
                      <select
                        style={ { width: '80px' } }
                        className='form-control'
                        onChange={ (e) => handleSelectChange(e, i) }
                        defaultValue={ value.verified }>
                        <option value=''>-pilih-</option>
                        <option value='no'>no</option>
                        <option value='yes'>yes</option>
                      </select>
                    ),
                    <input
                      style={ { width: '150px' } }
                      className='form-control'
                      disabled={ isFormDisabled[ i ] || verifiedComplete[ value.id ] }
                      placeholder={ `${ isFormDisabled[ i ] ? '' : 'keterangan' }` }
                      type='text'
                      value={ keterangan[ i ] }
                      onChange={ (e) => handleChange(e, i) }
                    />,
                    value.verified === 'yes' || verifiedComplete[ value.id ] ? (
                      <span className='text-success'>
                        <i className='far fa-check-circle fa-2x' />
                      </span>
                    ) : (
                      <button
                        // disabled={ value.verified === 'yes' || !value.verified }
                        onClick={ () =>
                          handleSubmit(
                            {
                              id: value.ref_persyaratan_id,
                              status: verifiedStatus[ i ] || value.verified,
                              keterangan: keterangan[ i ],
                              index: i,
                            },
                            (status) => {
                              status === 'yes' &&
                                setVerifiedComplete((state) => ({
                                  ...state,
                                  [ value.id ]: 1,
                                }));
                              toast({
                                status: 'success',
                                text: 'Success',
                              });
                            }
                          )
                        }
                        className='btn btn-primary'>
                        Confirm
                      </button>
                    ),
                  ];
                } }
              />
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default View;
